module.exports = __webpack_public_path__ + "img/ico_consulta-hospitais.32f6c70e.svg";